import React, { Component } from "react";
import "../../../styles/components/legal/Legal.scss";
import KINTO_ICON from "../../../styles/images/brands/kinto.svg";

class TC extends Component {
  render() {
    return (
      <div className="kinto-section">
        <div className="header-kinto">
          <img
            className="brand-kinto"
            src={KINTO_ICON}
            name="Picture 1"
            align="bottom"
            border={0}
            alt="Acp"
          />
        </div>
        <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
          <font face="Toyota Display, serif">
            <font size={3} style={{ fontSize: "12pt" }}>
              <b>Termos e Condições</b>
            </font>
          </font>
        </p>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Os termos e condições seguintes (doravante referidos como "
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Termos e Condições</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              ”) regulam o acesso e a utilização da plataforma eletrónica de
              serviços de mobilidade elétrica KINTO CHARGE, disponível em{" "}
              <a href="https://webclient.go-KINTO.com/">
                https://webclient.go-KINTO.com
              </a>{" "}
              para os utilizadores empresariais e/ou na Play Store e na App
              Store (doravante, "
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>plataforma KINTO CHARGE</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              ”) para os utilziadores individuais, empresariais ou outras
              entidades que se registem nesta plataforma (doravante, o "
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Utilizador</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              ” ou os "
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Utilizadores</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              ”).
            </font>
          </font>
        </p>
        <ol>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A plataforma KINTO CHARGE destina-se a utilizadores de
                  veículos elétricos, bem como a agentes económicos e entidades
                  do setor público ou social que pretendam usufruir e/ou
                  promover os benefícios associados à mobilidade elétrica.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Ao aceder, instalar ou usar a plataforma KINTO CHARGE, o
                  Utilizador manifesta concordância, sem reservas, com os
                  presentes Termos e Condições, pelo que deve proceder à leitura
                  dos mesmos em momento prévio à utilização da plataforma KINTO
                  CHARGE.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Se não concordar com os presentes Termos e Condições, o
                  Utilizador não deve usar a plataforma KINTO CHARGE nem
                  descarregar ou subscrever qualquer material ou serviço que
                  esta disponibilize.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Os serviços são disponibilizados ao Utilizador pela seguinte
                  sociedade comercial:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          align="justify"
          style={{
            marginLeft: "1.27cm",
            marginBottom: "0.28cm",
            lineHeight: "0.64cm",
          }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>KINTO PORTUGAL, S.A.,</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              com sede na Avenida Vasco da Gama, 1410, Vila Nova de Gaia, pessoa
              coletiva n.º{" "}
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              502584866
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              (doravante, "
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>KINTO</b>
            </font>
          </font>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              ”), na qualidade de agente comercial, e que é titular exclusiva de
              todos os direitos relativos à plataforma KINTO CHARGE.
            </font>
          </font>
        </p>
        <ol start={5}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O Utilizador reconhece que os serviços prestados através da
                  plataforma KINTO CHARGE se dirigem a pessoas singulares
                  maiores de 18 anos e/ou a pessoas coletivas. No caso de pessoa
                  singular, ao aceder à plataforma KINTO CHARGE, o Utilizador
                  declara ser maior de 18 anos. O Utilizador reconhece e aceita
                  que o acesso e utilização da plataforma KINTO CHARGE são da
                  sua exclusiva responsabilidade, comprometendo-se a utilizar a
                  plataforma KINTO CHARGE e os respetivos serviços em
                  conformidade com a Lei e de acordo com os presentes Termos e
                  Condições.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO reserva-se o direito de modificar e/ou atualizar os
                  presentes Termos e Condições sempre que o considere
                  pertinente, mediante o respetivo alerta prévio na plataforma
                  KINTO CHARGE e envio de e-mail aos Utilizadores registados, a
                  fim de as alterações poderem ser conhecidas de modo informado
                  pelos Utilizadores no momento em que acedam à plataforma KINTO
                  CHARGE e previamente a uma nova utilização desta. Após uma
                  alteração dos presentes Termos e Condições e respetiva
                  comunicação ao Utilizador, a utilização subsequente da
                  plataforma KINTO CHARGE significa a aceitação tácita por parte
                  do Utilizador dos Termos e Condições modificados.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  As diferentes componentes do tarifário e/ou a fórmula de
                  cálculo do valor em cada momento devido pelo Utilizador como
                  contrapartida pelos serviços da plataforma KINTO CHARGE de
                  utilização de postos de carregamento são disponibilizadas ao
                  Utilizador imediatamente antes da realização da respetiva
                  operação utilizando, para o efeito, quer informação da própria
                  KINTO CHARGE, quer também informação prestada por entidades
                  terceiras, nomeadamente, entidades gestoras de redes e/ou
                  postos de postos de carregamento, reguladores e autoridades
                  tributárias.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Os presentes Termos e Condições estão disponíveis nas
                  aplicações de utilização da plataforma KINTO CHARGE para
                  consulta pelo Utilizador, salvo situações de indisponibilidade
                  de sistemas ou outro erro alheio à KINTO que impeça a
                  disponibilização da informação.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O Utilizador deve manter uma cópia dos presentes Termos e
                  Condições num ficheiro autónomo, no seu dispositivo ou em
                  formato de papel, para referência futura, sem prejuízo de os
                  registos digitais da plataforma KINTO CHARGE associados à
                  prestação de cada serviço serem considerados suficientes para
                  efeitos de prova contratual.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Os presentes Termos e Condições regem-se e são interpretados
                  de acordo com a Lei portuguesa, aceitando o Utilizador
                  submeter-se à jurisdição exclusiva dos tribunais portugueses
                  para a resolução de quaisquer litígios relacionados com os
                  mesmos, sem prejuízo do disposto em "Resolução de conflitos”.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Caso os postos de carregamento utilizados no âmbito do
                  presente contrato não pertençam à rede KINTO CHARGE, em tal
                  caso, poderão ser aplicados os respetivos Termos e Condições
                  pertencentes às entidades terceiras responsáveis pela
                  distribuição do serviço. Em tais casos, a KINTO atuará como
                  comercializador e a entidade identificada como distribuidor,
                  sendo da exclusiva responsabilidade do Utilizador proceder à
                  leitura e respetiva aceitação dos Termos e Condições
                  referidos.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Tratamento de dados pessoais</b>
            </font>
          </font>
        </p>
        <ol start={12}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O Utilizador reconhece expressamente que, para que os serviços
                  descritos na plataforma KINTO CHARGE possam ser prestados, a
                  KINTO necessita de recolher e tratar certas informações do
                  Utilizador, incluindo dados de natureza pessoal.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Antes de utilizar e subscrever a plataforma KINTO CHARGE, o
                  Utilizador deve consultar a Política de Privacidade, onde
                  encontrará detalhadas as condições de recolha e tratamento dos
                  seus dados pessoais, os direitos que lhe assistem, bem como
                  outras informações relacionadas com o tratamento de dados
                  pessoais realizados pela KINTO.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Serviços</b>
            </font>
          </font>
        </p>
        <ol start={14}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A plataforma KINTO CHARGE permite ao Utilizador beneficiar dos
                  seguintes serviços e funcionalidades:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <ol type="a">
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Serviços de mobilidade elétrica, que incluem a utilização de
                    postos de carregamento e o carregamento de veículos
                    elétricos em espaços onde existam postos de carregamento
                    conectados à rede KINTO CHARGE;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Serviços de mobilidade elétrica, que incluem a utilização de
                    postos de carregamento e o carregamento de veículos
                    elétricos em postos de outras redes (roaming), a nível
                    nacional e internacional, que tenham acordo e integração com
                    a KINTO CHARGE, sendo aplicável em Portugal o previsto no
                    Anexo I aos presentes Termos e Condições;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Gestão de postos de carregamento e dos respetivos
                    utilizadores;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Gestão de consumos de veículos elétricos e dos respetivos
                    utilizadores;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Acompanhamento do estado dos serviços;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Histórico de consumos e transações;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Estatísticas sobre os consumos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Planeamento de rotas;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Comparação de custos entre postos de carregamento;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Localização de postos de carregamento e consulta da sua
                    disponibilidade;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Simulação de custo num posto de carregamento;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Suporte ao Utilizador, através de FAQ e menu "Contacte-nos”.
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Acesso e condições de adesão</b>
            </font>
          </font>
        </p>
        <ol start={15}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A plataforma KINTO CHARGE está disponível em{" "}
                  <a href="https://webclient.go-KINTO.com/">
                    https://webclient.go-KINTO.com
                  </a>
                  , e/ou, enquanto App, na Play Store e na App Store, consoante
                  o tipo de adesão do Utilizador. O acesso através de
                  smartphones pressupõe a utilização do sistema operativo IOS
                  (versão mínima suportada IOS 13.0) ou Android (versão mínima
                  suportada 6.0).
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A utilização da plataforma KINTO CHARGE e o acesso aos
                  respetivos serviços por pessoa singular implica a efetivação
                  de registo na App para telemóvel pelo Utilizador.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Ao registar-se na plataforma KINTO CHARGE, o Utilizador irá,
                  para efeitos de autenticação, receber um SMS, e/ou um email de
                  confirmação de registo.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Com a utilização da plataforma KINTO CHARGE, o Utilizador
                  assegura que todos os dados pessoais introduzidos por si são
                  verdadeiros, atuais e completos. Qualquer ato do Utilizador
                  que seja considerado pela KINTO como ilegal, fraudulento ou
                  enganador confere a esta o direito de inibir o Utilizador de
                  ter acesso à plataforma KINTO CHARGE, podendo esta inibição
                  resultar também de decisão judicial ou ordem administrativa.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Condições de utilização dos serviços, preços e tarifários</b>
            </font>
          </font>
        </p>
        <ol start={19}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Os serviços descritos no número 14 têm as seguintes condições
                  de utilização:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ul>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Alíneas a) a g) – são pagos;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Alíneas h) a i) - são disponibilizados gratuitamente com
                  limites de utilização, podendo o Utilizador pagar para ter
                  acesso a limites superiores;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Alíneas j) a k) - são gratuitos.
                </font>
              </font>
            </p>
          </li>
        </ul>
        <ol start={20}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Relativamente aos serviços descritos nas alíneas a) e b) do
                  número 14:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="i">
          <ol type="a">
            <ol type="i">
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A KINTO disponibiliza um serviço para Utilizadores de
                      veículos elétricos, que incorpora o uso de um local para
                      estacionamento e carregamento;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A plataforma KINTO CHARGE disponibiliza carregamentos{" "}
                    </font>
                  </font>
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <i>ad hoc</i>
                    </font>
                  </font>
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      em várias redes através de contratos instantâneos entre a
                      EVIO e o Utilizador;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Ao aceder aos postos de carregamento, o Utilizador
                      obriga-se a respeitar todas as regras de utilização e
                      condições técnicas e de segurança aplicáveis e afixadas no
                      posto de carregamento em que o Utilizador se encontre;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      O serviço de mobilidade elétrica que inclui carregamento
                      inicia-se com a ativação do serviço pelo Utilizador
                      através da plataforma KINTO CHARGE e termina com a
                      respetiva desativação;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Antes de iniciar o carregamento da sua viatura e para que
                      o serviço possa ser prestado, o Utilizador terá de
                      selecionar o posto de carregamento e tomada onde pretende
                      usufruir do serviço e efetuar a sua autenticação. A
                      autenticação pode ser realizada através de leitura de um
                      QR-Code (quando disponível) ou através de menu apropriado
                      na App ou de cartão físico (quando disponibilizado pela
                      KINTO CHARGE);
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      O valor a cobrar pelo serviço será medido através do tempo
                      de utilização do serviço e/ou dos kWh consumidos, podendo
                      acrescer uma componente de ativação dos serviços, roaming
                      e/ou de estacionamento após o término do carregamento. Os
                      valores fixados dependem da qualidade do local de
                      carregamento, tempo de utilização do posto de
                      carregamento, rede onde estão ligados os postos de
                      carregamento, potência do local, pontos de interesse nos
                      locais e outros serviços disponíveis. O Utilizador deve
                      consultar previamente na plataforma KINTO CHARGE o
                      tarifário a cobrar para cada ponto de carregamento. Em
                      função das redes e dos locais, pode haver lugar à
                      incidência de tarifas praticadas por terceiros, taxas e
                      eventuais impostos;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Os custos em que a KINTO possa eventualmente incorrer
                      relacionados com o tempo máximo de utilização do serviço
                      ou de inatividade, bem como os custos de coimas ou
                      serviços de reboque decorrentes de estacionamento indevido
                      ou abusivo, serão imputados ao Utilizador, em conformidade
                      com o disposto na legislação e/ou regulamentação
                      aplicável;
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                >
                  <font face="Toyota Display, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A KINTO não é responsável por qualquer custo, dano,
                      prejuízo ou lucro cessante que possa resultar para o
                      Utilizador da indisponibilidade ou de mau funcionamento do
                      posto de carregamento selecionado através da plataforma
                      KINTO CHARGE, sendo essa responsabilidade efetivada pelo
                      Utilizador junto da entidade proprietária e/ou responsável
                      pela operação do posto de carregamento.
                    </font>
                  </font>
                </p>
              </li>
            </ol>
          </ol>
        </ol>
        <ol start={21}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  No final da utilização de cada serviço de utilização de posto
                  de carregamento sujeito a pagamento, a plataforma KINTO CHARGE
                  apresenta ao Utilizador o valor a cobrar pelo serviço
                  prestado, assim como o respetivo detalhe.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Em caso de insucesso na cobrança do serviço, a KINTO
                  reserva-se o direito de bloquear a utilização de todos os
                  serviços pelo Utilizador. Para voltar a utilizar os serviços,
                  o Utilizador deve atualizar os seus meios de pagamento e pagar
                  o valor em dívida.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Operacionalidade da plataforma KINTO</b>
            </font>
          </font>
        </p>
        <ol start={23}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO reserva-se o direito de interromper ou suspender
                  temporariamente, e sem aviso prévio, o acesso à plataforma
                  KINTO CHARGE pelo período que determine como necessário, por
                  quaisquer razões de ordem técnica, administrativa ou de força
                  maior. O Utilizador reconhece que as interrupções no serviço
                  podem ocorrer devido a situação de força maior, nesta se
                  incluindo tremores de terra, inundações, incêndios, epidemias,
                  sabotagens, greves, embargos ou bloqueios internacionais, atos
                  de guerra ou terrorismo, motins, situações de emergência,
                  contingência ou estado de alarme provocado por uma epidemia ou
                  pandemia, bem como devido a ações técnicas que tenham de ser
                  realizadas no equipamento para que este funcione corretamente
                  ou para melhorar o serviço (por exemplo, manutenção,
                  reparações, indisponibilidade de plataformas ou serviços de
                  terceiros, atualizações de software nos sistemas, nos
                  servidores, e/ou nas estações de carregamento). As
                  interrupções, ou redução do nível de serviço, podem também
                  resultar de falta de capacidade de curto prazo devido a picos
                  de utilização, resultantes de um acesso em simultâneo de
                  vários Utilizadores à plataforma KINTO CHARGE, com o
                  carregamento na potência máxima.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO pode, a todo o tempo e sem aviso prévio, alterar a
                  apresentação e configuração da plataforma KINTO CHARGE.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO compromete-se a realizar todos os esforços no sentido
                  de manter a operacionalidade e continuidade da plataforma
                  KINTO CHARGE, para evitar a presença de vírus ou outros
                  elementos lesivos que possam provocar alterações no sistema
                  informático do Utilizador, bem como para fornecer informação
                  exata e atualizada. No entanto, e dada a interligação com
                  diferentes entidades que constituem fonte de informação da
                  plataforma KINTO CHARGE, os conteúdos poderão não estar sempre
                  atualizados, apesar do esforço efetuado de forma regular para
                  esse efeito, nem a KINTO CHARGE garante que a plataforma KINTO
                  CHARGE funcione corretamente a todo o momento, de forma
                  rápida, ininterrupta e livre de erros. Igualmente, a KINTO não
                  pode garantir a ausência de vírus ou elementos lesivos que
                  possam provocar alterações nos sistemas informáticos dos
                  Utilizadores, nos seus documentos eletrónicos ou nos seus
                  ficheiros.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Em particular, e salvaguardadas situações de atuação dolosa ou
                  com negligência grosseira por parte da KINTO, em conformidade
                  com a lei, a KINTO não se responsabiliza pelos danos ou
                  prejuízos verificados na esfera do Utilizador que possam
                  resultar de:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <ol type="a">
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Dispositivos móveis utilizados pelo Utilizador;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Impossibilidade ou dificuldades de utilização da plataforma
                    KINTO CHARGE, incluindo, nomeadamente, atrasos,
                    interrupções, avarias, suspensão de comunicações, vírus,
                    suspensão ou qualquer outro impedimento dos servidores onde
                    o sistema se encontra alojado;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Atrasos ou bloqueios no uso causados por deficiências ou
                    sobrecargas de Internet ou em outros sistemas eletrónicos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Possíveis erros ou deficiências de segurança que possam
                    ocorrer pelo uso, por parte do Utilizador, de equipamentos,
                    terminais ou browsers desatualizados ou inseguros;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Falta de qualidade, atualidade, veracidade, licitude,
                    exatidão, completude, fiabilidade e/ou idoneidade de
                    conteúdos elaborados, produzidos, ou emitidos por terceiros,
                    assim como da existência de vícios ou defeitos de qualquer
                    tipo dos conteúdos transmitidos, difundidos, armazenados
                    e/ou colocados à disposição dos Utilizadores por tais
                    terceiros a que os Utilizadores acedam através da plataforma
                    KINTO CHARGE ou dos serviços oferecidos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Atuações de terceiros que violem direitos de propriedade
                    intelectual, segredos empresariais, direito à honra, à
                    intimidade pessoal e à própria imagem, assim como a
                    legislação em matéria de concorrência desleal e publicidade
                    ilícita;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Acessibilidade, funcionamento ou disponibilidade de
                    conteúdos, informação e serviços oferecidos por terceiros
                    nos portais ligados à plataforma KINTO CHARGE, assim como da
                    sua qualidade, licitude, fiabilidade e utilidade. O
                    Utilizador reconhece que a plataforma KINTO CHARGE pode
                    estar hiperligada a outros sites e que a KINTO não está,
                    direta ou indiretamente, a sugerir qualquer aprovação,
                    associação, ligação ou relação com o site hiperligado, a não
                    ser que esteja especificamente aí estabelecido. Ao entrar na
                    plataforma KINTO CHARGE, o Utilizador reconhece e aceita que
                    a KINTO não reviu todos os sites hiperligados à plataforma
                    KINTO CHARGE, não sendo responsável pelo conteúdo de
                    qualquer das páginas off-site ou qualquer site a ele
                    hiperligado. A ligação do Utilizador a quaisquer outras
                    páginas off-site ou outros sites corre por sua própria conta
                    e risco.
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
        <ol start={27}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO eliminará os conteúdos disponibilizados por terceiros
                  na plataforma KINTO CHARGE no caso de ter conhecimento efetivo
                  de que estes são manifestamente ilegais ou infringem direitos
                  de terceiros, ou no caso de tal ser ordenado por decisão
                  judicial ou ordem administrativa.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A utilização e a qualidade da plataforma KINTO CHARGE, em
                  especial quando acedida através de App, dependem do
                  dispositivo móvel utilizado para aceder à mesma, devendo o
                  Utilizador certificar-se que o equipamento e o respetivo
                  sistema operativo utilizado suportam a App. Ao descarregar a
                  App, o Utilizador reconhece e aceita que o seu dispositivo
                  móvel permite o funcionamento daquela.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Cabe ao Utilizador manter e conservar o dispositivo móvel no
                  qual descarregue a App em condições de segurança e seguir as
                  práticas de segurança aconselhadas pelo fabricante e pela
                  operadora de telecomunicações, devendo instalar e manter
                  atualizados os necessários mecanismos de segurança,
                  nomeadamente, um antivírus.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Qualquer falha no funcionamento da App decorrente da falta de
                  cumprimento do disposto nos números anteriores será da
                  exclusiva responsabilidade do Utilizador, reconhecendo este
                  último que em caso algum poderá a KINTO ser responsabilizada.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A plataforma KINTO CHARGE (incluindo a respetiva App) é
                  fornecida para uso exclusivo do Utilizador, que se compromete
                  a fazer uso da mesma em conformidade com a Lei e com os
                  presentes Termos e Condições, obrigando-se, designadamente, a
                  não a utilizar para fins ilícitos, contrários ao estabelecido
                  nos Termos e Condições, lesivos dos direitos e interesses de
                  terceiros ou que, de qualquer forma, possam danificar,
                  inutilizar, sobrecarregar ou deteriorar o funcionamento normal
                  da plataforma KINTO CHARGE.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO reserva-se o direito de bloquear o acesso do
                  Utilizador à App, assim como às respetivas funcionalidades
                  desta, caso o Utilizador não cumpra o disposto nos números 27,
                  28, e 29.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O Utilizador deverá reportar à KINTO quaisquer anomalias que
                  detete relativamente ao uso da plataforma KINTO CHARGE, bem
                  como quaisquer ações fraudulentas de terceiros. É vedado ao
                  Utilizador um uso abusivo das aplicações e da plataforma KINTO
                  CHARGE.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Direitos de propriedade intelectual</b>
            </font>
          </font>
        </p>
        <ol start={34}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O conteúdo e a estrutura da plataforma KINTO CHARGE, incluindo
                  aplicações, software, algoritmos, arquitetura, design, look
                  &amp; feel, base de dados, libraries, trabalhos derivados e
                  desenvolvimentos futuros, é protegido por direitos de
                  propriedade intelectual da KINTO e/ou de qualquer outro
                  Terceiro Licenciador, que abrangem direitos de autor e
                  direitos conexos e direitos de propriedade industrial, ao
                  abrigo da legislação portuguesa e europeia, incluindo, mas não
                  limitando, direitos sui generis do autor de bases de dados,
                  direitos sobre design, obras e elementos publicitários,
                  invenções (incluindo patentes e modelos industriais), modelos
                  e desenhos, sinais distintivos de comércio (incluindo marcas,
                  logótipos, recompensas, nomes de estabelecimento e insígnias),
                  firmas e nomes comerciais, bem como segredos comerciais,
                  know-how e todos os outros direitos de caráter semelhante,
                  incluindo pedidos e aplicações para registo e
                  independentemente de tal registo ter sido efetuado ou de os
                  direitos em questão não estarem sujeitos a registo.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  É vedado, em qualquer circunstância, adaptar, tentar modificar
                  ou alterar o código-fonte, efetuar operações de engenharia
                  reversa, criar obras derivadas do software, descompilar ou
                  desmontar, no todo ou em parte, qualquer dos elementos que
                  integram a plataforma KINTO CHARGE, bem como reproduzir,
                  transferir, ceder, alugar, vender ou de qualquer outro modo
                  transmitir direitos de utilização da plataforma KINTO CHARGE,
                  temporária ou permanentemente, salvo autorização expressa da
                  KINTO.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Todas as tentativas de adulteração dos conteúdos ou da
                  estrutura da plataforma KINTO CHARGE e seus meios anexos, ou
                  qualquer outra ação que possa causar danos e pôr em risco a
                  integridade do sistema, podem ser objeto de processo judicial.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Resolução e denúncia</b>
            </font>
          </font>
        </p>
        <ol start={37}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A KINTO poderá resolver o contrato de adesão aos presentes
                  Termos e Condições relativamente a um Utilizador quando ocorra
                  alguma violação dos mesmos, mediante comunicação escrita.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Os Termos e Condições cessam também quando a KINTO ou o
                  Utilizador os denuncie, mediante comunicação escrita com um
                  pré-aviso de 15 dias e 30 dias.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  A verificação de qualquer uma das situações acima referidas
                  implica a cessação/impedimento de utilização da plataforma
                  KINTO CHARGE pelo Utilizador.
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Direito de livre resolução na prestação de serviços B2C</b>
            </font>
          </font>
        </p>
        <ol start={40}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Nos casos em que o Utilizador seja uma pessoa singular que
                  atue, no contexto dos presentes Termos e Condições, com fins
                  que não se integrem no âmbito da sua atividade comercial,
                  industrial, artesanal ou profissional (i.e., um consumidor) e
                  tenha subscrito serviços B2C com pagamento associado através
                  da plataforma KINTO CHARGE, o mesmo tem o direito de,
                  livremente, sem necessidade de indicar o motivo, e sem haver
                  lugar ao pagamento de uma indemnização, resolver o contrato no
                  prazo de 14 dias a contar da data de subscrição dos serviços.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O disposto no número anterior não prejudica a obrigação do
                  Utilizador efetuar o pagamento do montante correspondente aos
                  serviços prestados até ao momento da comunicação da resolução,
                  caso os mesmos se tenham iniciado no referido período de 14
                  dias a contar da data de subscrição.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Caso o Utilizador pretenda exercer o seu direito de livre
                  resolução previsto no nº 44 deverá comunicar à KINTO, dentro
                  do prazo de 14 dias acima referido, a sua decisão de resolução
                  por meio de uma declaração inequívoca, que poderá ser
                  comunicada para o email{" "}
                  <a href="mailto:charge@kinto-mobility.pt">
                    charge@kinto-mobility.pt
                  </a>
                  .
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Comunicações</b>
            </font>
          </font>
        </p>
        <ol start={43}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Caso a KINTO necessite de entrar em contacto com o Utilizador,
                  poderá utilizar os seguintes canais: carta, e-mail, SMS e
                  notificações push.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Mediante o consentimento do utilizador, a KINTO poderá enviar
                  comunicações relativas a:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <ol type="a">
            <ol type="i">
              <ol type="a">
                <li>
                  <p
                    align="justify"
                    style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                  >
                    <font face="Toyota Display, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Novas funcionalidades e serviços da App KINTO CHARGE;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    align="justify"
                    style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                  >
                    <font face="Toyota Display, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Novos produtos e promoções da KINTO;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    align="justify"
                    style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
                  >
                    <font face="Toyota Display, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Newsletters e outras informações de marketing relativas
                        à marca KINTO e respetivas parcerias.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </ol>
          </ol>
        </ol>
        <ol start={45}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  O Utilizador poderá contactar a KINTO através dos seguintes
                  canais:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Atendimento telefónico comercial, através do número
                  disponibilizado na plataforma KINTO CHARGE para o efeito;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Através de formulário eletrónico de contacto disponível em{" "}
                  <a href="https://webclient.go-KINTO.com/">
                    https://webclient.go-KINTO.com
                  </a>
                  ;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Através do endereço de correio eletrónico{" "}
                  <a href="mailto:charge@kinto-mobility.pt">
                    charge@kinto-mobility.pt
                  </a>
                  ;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Funcionalidade de suporte existente na App KINTO CHARGE para
                  telemóvel;
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Através de carta, enviada para a morada{" "}
                </font>
              </font>
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Av. Vasco da Gama 780, 4430-247, Vila Nova de Gaia
                </font>
              </font>
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  .
                </font>
              </font>
            </p>
          </li>
        </ol>
        <br />
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Resolução de conflitos</b>
            </font>
          </font>
        </p>
        <ol start={46}>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Em caso de existência de conflito, nomeadamente sobre a
                  interpretação, execução e aplicação das disposições legais ou
                  contratuais aplicáveis, o Utilizador e a KINTO procurarão
                  resolvê-lo amigavelmente.
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
            >
              <font face="Toyota Display, serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Sem prejuízo da possibilidade de recorrer aos tribunais
                  judiciais, o Utilizador de serviços B2C pode optar por
                  solicitar a intervenção de uma entidade de resolução
                  alternativa de litígios, nomeadamente através do recurso aos
                  mecanismos de arbitragem e mediação de conflitos previstos no
                  site da Direção-Geral do Consumidor em{" "}
                  <a href="https://www.consumidor.gov.pt/ral-mapa-e-lista-de-%20entidades.aspx">
                    https://www.consumidor.gov.pt/ral-mapa-e-lista-de-
                    entidades.aspx
                  </a>{" "}
                  e a seguir indicados:
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          align="justify"
          style={{
            marginLeft: "1.25cm",
            marginBottom: "0.28cm",
            lineHeight: "0.64cm",
          }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              CNIACC – Centro Nacional de Informação e Arbitragem de Conflitos
              de Consumo (www.arbitragemdeconsumo.org ); CIMAAL – Centro de
              Informação, Mediação e Arbitragem de Conflitos de Consumo do
              Algarve (www.consumidoronline.pt ); Centro de Arbitragem de
              Conflitos de Consumo do Distrito de Coimbra
              (www.centrodearbitragemdecoimbra.com ); Centro de Arbitragem de
              Conflitos de Consumo de Lisboa (www.centroarbitragemlisboa.pt );
              Centro de Informação de Consumo e Arbitragem do Porto
              (www.cicap.pt ); Centro de Arbitragem de Conflitos de Consumo do
              Vale do Ave (www.triave.pt ); Centro de Informação, Mediação e
            </font>
          </font>
        </p>
        <p
          align="justify"
          style={{
            marginLeft: "1.25cm",
            marginBottom: "0.28cm",
            lineHeight: "0.64cm",
          }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Arbitragem de Consumo (www.ciab.pt); Centro de Arbitragem de
              Conflitos de Consumo da Madeira (www.srrh.gov-madeira.pt ) e
              Centro de Arbitragem da Universidade Autónoma de Lisboa
              (http://arbitragem.autonoma.pt).
            </font>
          </font>
        </p>
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        ></p>
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <br />
          <br />
        </p>
        <p
          align="center"
          style={{
            marginBottom: "0.28cm",
            lineHeight: "108%",
            pageBreakBefore: "always",
          }}
        >
          <span style={{ textTransform: "uppercase" }}>
            <font face="Toyota Display, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>Anexo I</b>
              </font>
            </font>
          </span>
        </p>
        <p
          align="center"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <span style={{ textTransform: "uppercase" }}>
            <font face="Toyota Display, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>
                  Carregamento de veículos elétricos em postos integrados na
                  rede portuguesa MOBI.E
                </b>
              </font>
            </font>
          </span>
        </p>
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <br />
          <br />
        </p>
        <p
          align="justify"
          style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
        >
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              A plataforma KINTO CHARGE disponibiliza carregamentos ad hoc na
              rede MOBI.E através de contratos instantâneos entre a{" "}
            </font>
          </font>
          <span style={{ textTransform: "uppercase" }}>
            <font face="Toyota Display, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>EVIO - Electrical Mobility, S.A.</b>
              </font>
            </font>
          </span>
          <font face="Toyota Display, serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              , na qualidade de comercializador de eletricidade para a
              mobilidade elétrica, titular do registo n.º 20, de 10 de julho de
              2020 ("CEME”), e o Utilizador, nas condições constantes dos
              números seguintes:
            </font>
          </font>
        </p>
        <br />
        <ol type="a">
          <ol>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Ao aceder aos postos de carregamento da rede MOBI.E, o
                    Utilizador obriga-se a cumprir as Condições de Utilização da
                    Rede de Mobilidade Elétrica (disponível em{" "}
                    <a href="https://www.mobie.pt/utilizar-a-rede">
                      https://www.mobie.pt/utilizar-a-rede
                    </a>
                    ) em cada momento vigentes e a respeitar todas as regras de
                    utilização e condições técnicas e de segurança aplicáveis e
                    afixadas no posto de carregamento em que o Utilizador se
                    encontre.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    O preço de fornecimento devido pelo Utilizador por cada
                    carregamento de bateria de veículo elétrico é composto pelo
                    somatório das seguintes componentes:
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
        <ol type="a">
          <ol type="a">
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Preço de energia, em função da quantidade total de
                    eletricidade em quilowatt hora (kWh) fornecida em cada
                    carregamento;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Preço de utilização do ponto de carregamento, afixado no
                    local e que é cobrado pelo operador do ponto de carregamento
                    ("OPC”) à EVIO, na qualidade de CEME, que o repercute no
                    preço devido pelo utilizador;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Tarifas de ativação praticadas pelo CEME e OPC;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Tarifas de acesso às redes de energia elétrica para a
                    mobilidade elétrica, fixadas pela Entidade Reguladora dos
                    Serviços Energéticos ("ERSE”), calculadas em função do tipo
                    de fornecimento (ponto de entrega da Rede Elétrica de
                    Serviço Público à rede da mobilidade elétrica em baixa
                    tensão ou média tensão) e período horário;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    IVA à taxa legal em vigor no momento da emissão da fatura,
                    Imposto Especial sobre o Consumo, bem como eventuais outros
                    impostos, taxas, encargos ou contribuições legalmente
                    aplicáveis ao fornecimento de eletricidade para a mobilidade
                    elétrica no momento da emissão da fatura;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Apoios financeiros do Estado traduzidos em desconto a
                    aplicar ao custo de cada carregamento registado na rede de
                    mobilidade elétrica portuguesa
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
        <ol type="a">
          <ol start={3}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    O Utilizador é informado e dá consentimento a um eventual
                    tratamento de dados pessoais (endereço de e-mail) pela
                    Entidade Gestora da Mobilidade Elétrica ("EGME”) para
                    efeitos de notificação da cessação do contrato de adesão à
                    rede de mobilidade elétrica relativamente ao CEME EVIO, nos
                    termos previstos no Regulamento da Mobilidade Elétrica.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    O Utilizador pode apresentar reclamação através de qualquer
                    um dos canais de atendimento referidos no número anterior ou
                    através do livro de reclamação em formato eletrónico, cujo
                    acesso é disponibilizado através de página de internet.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    A EVIO obriga-se a responder a todas as reclamações que lhe
                    sejam dirigidas através de qualquer um dos canais de
                    atendimento acima indicados no prazo máximo de 15 dias úteis
                    após a data da sua receção.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Display, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    A EVIO não fica obrigada a suportar qualquer compensação ao
                    Cliente nas situações originadas por casos fortuitos ou de
                    força maior, no sentido dado pelo artigo 8.º do Regulamento
                    da Qualidade de Serviço, aprovado pelo Regulamento n.º
                    406/2021, de 12 de maio, da ERSE.
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
      </div>
    );
  }
}

export default TC;
